import React from 'react';

import { MenuWithStore } from '@crm-framework/menu/src/MenuWithStore';
import { Permissions } from '@crm-framework/auth';

import { USER_RIGHTS } from '@crm-package/auth';
import { apiLogout } from '@crm-package/auth/api';
import ChatButtonInject from '@crm-package/chat';

import { Bell } from './Bell';
import { apiGetMenu } from './api';

interface IMenuWithStoreProps {
  activeLink: string;
  apiMenu: string;
}

export const Menu: React.VFC<IMenuWithStoreProps> = ({
  activeLink,
  apiMenu,
}) => {
  const api = {
    apiLogout: async () => apiLogout(),
    apiGetMenu: async () => apiGetMenu(apiMenu),
  };

  return (
    <MenuWithStore
      api={api}
      bellComponent={<Bell />}
      chatComponent={
        <Permissions
          viewRights={[
            USER_RIGHTS.XCHAT_ALLOW_TO_CHAT_ALL,
            USER_RIGHTS.XCHAT_ALLOW_TO_CHAT_ASSIGNED,
          ]}
          isAccessAllowedByOneOfRight
          FallbackComponent={null}>
          <ChatButtonInject />
        </Permissions>
      }
      activeLink={activeLink}
    />
  );
};
